import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./marketing.css";

import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { HashRouter } from "react-router";
import { App } from "./App";
import i18n from "./i18n";
import { Log } from "./shared/logging/Log";
import { theme } from "./theme";

Log.logger.info("Starting app...");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <ModalsProvider>
          <Notifications position="top-right" />
          <HashRouter>
            <App />
          </HashRouter>
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  </I18nextProvider>,
);
